<!--
2023-05-24 Matt 常态化下注流水返利活动
-->
<template>
  <div class="betActivityRegularlyDetailsPage">
    <TopBack :title="$t('lang.betActivityRegularly.details')" />

    <div class="summary">
      <div class="totalReceived">
        <div class="title">
          {{ $t('lang.betActivityRegularly.totalReceived') }}
        </div>
        <div class="amount">
          {{userInfo ? fetchCurrency[userInfo.CurrencyName] : ''}}{{ separateThousand(totalReceived) }}
        </div>
      </div>
      <div class="totalRewards">
        <div class="title">
          {{ $t('lang.betActivityRegularly.totalRewards') }}
        </div>
        <div class="amount">
          {{ userInfo ? fetchCurrency[userInfo.CurrencyName] : '' }}{{ separateThousand(totalRewards) }}
        </div>
      </div>
      <div class="totalBet">
        <div class="title">
          {{ $t('lang.betActivityRegularly.totalBet') }}
        </div>
        <div class="amount">
          {{ userInfo ? fetchCurrency[userInfo.CurrencyName] : '' }}{{ separateThousand(totalBet) }}
        </div>
      </div>
    </div>

    <div class="statsByGames">
      <table>
        <tr>
          <th>
            {{ $t('lang.betActivityRegularly.games') }}
          </th>
          <th>
            {{ $t('lang.betActivityRegularly.bet') }}
          </th>
          <th>
            {{ $t('lang.betActivityRegularly.rewards') }}
          </th>
        </tr>
        <tr v-for="(datum, index) in statsByGames" :key="index">
          <td>
            {{ datum.GameCatetory }}
          </td>
          <td>
            {{ userInfo ? fetchCurrency[userInfo.CurrencyName] : '' }}{{ separateThousand(datum.BetAmount) }}
          </td>
          <td>
            {{ userInfo ? fetchCurrency[userInfo.CurrencyName] : '' }}{{ separateThousand(datum.Rewards) }}
          </td>
        </tr>
        <tr v-if="statsByGames.length === 0">
          <td colspan="3" style="font-size: 12px; color: #696969; text-align: center">
            {{ $t('lang.betActivityRegularly.noDataAvailable') }}
          </td>
        </tr>
      </table>
    </div>

    <div class="history">
      <div class="title">
        {{ $t('lang.betActivityRegularly.records') }}
      </div>
      <div id="memos" class="memos">
        <Loadmore
          :bottomPullText="''"
          :bottomDropText="''"
          :bottomLoadingText="''"
          :auto-fill="true"
          :bottom-method="loadMoreMemos"
          :bottom-all-loaded="allLoaded"
          ref="loadmore"
        >
          <div class="memo" v-for="(memoItem, index) in memos"  :key="index">
            <div class="categoryAndDate">
              <div class="category" :style="memoItem.Status === '40' ? 'color:red' : ''">
                {{ memoItem.Status === "40" ? $t('lang.betActivityRegularly.receive') : $t('lang.betActivityRegularly.rewards')}}
              </div>
              <div class="date">
                {{ new Date(memoItem.BetDate).toDateString({dateStyle: 'short'}) }}
              </div>
            </div>
            <div class="amount">
              {{ userInfo ? fetchCurrency[userInfo.CurrencyName] : '' }}{{ separateThousand(memoItem.Reward) }}
            </div>
          </div>
        </Loadmore>
        <div class="noDataAvailable" v-if="memos.length === 0">
          {{ $t('lang.betActivityRegularly.noDataAvailable') }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {Loadmore} from 'mint-ui'
import request from '@/service'
import { separateThousand } from '@/utils'
import { fetchCurrency } from '@/constant'

import TopBack from '@/components/TopBack/index'

export default {
  name: 'betActivityRegularlyDetails',
  data () {
    return {
      separateThousand,
      fetchCurrency,
      accountInfo: {},
      userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
      totalReceived: 0,
      totalRewards: 0,
      totalBet: 0,
      statsByGames: [],
      statsByGamesbak: [],
      firstLoad: true,
      allLoaded: false,
      memos: []
    }
  },
  components: {
    Loadmore,
    TopBack
  },
  watch: {
    '$store.state.locale': function () {
      this.changeLocale()
    }
  },
  mounted () {
    this.getTotalSummary()
  },
  methods: {
    loadMoreMemos () {
      const userUniqueId = this.userInfo.UserId
      const MemoBetDate = this.memos.length > 0 ? this.memos[this.memos.length - 1].BetDate : null
      const url = '/innovation/activity-normal/get-reward-particular'

      request('post', url, {
        UserId: userUniqueId,
        MemoBetDate
      }).then(res => {
        if (res.length > 0) {
          this.memos = this.memos.concat(res)
        } else {
          this.allLoaded = true
        }
        this.$refs.loadmore.onBottomLoaded()
      }).catch(err => {
        console.log(err)
      }).finally(e => {
        if (this.firstLoad) {
          document.getElementById('memos').scrollTop = 0
          this.firstLoad = false
        }
      })
    },
    getTotalSummary () {
      const userUniqueId = this.userInfo.UserId
      request('post', '/innovation/activity-normal/get-total-reward', {
        UserId: userUniqueId
      }).then(res => {
        this.totalReceived = res.TotalReceived
        this.totalRewards = res.TotalRewards
        this.totalBet = res.TotalBetAmount
        this.statsByGames = this.processingLanguage(res.GameCatetoryRewards)
        this.statsByGamesbak = res.GameCatetoryRewards
      })
    },
    changeLocale () {
      if (this.statsByGamesbak) {
        this.statsByGames = this.processingLanguage(this.statsByGamesbak)
      } else {
        this.getTotalSummary()
      }
    },
    processingLanguage (rewards) {
      if (!rewards) {
        return rewards
      }
      return rewards.map(r => {
        let obj = {}
        obj.BetAmount = r.BetAmount
        obj.Rewards = r.Rewards
        obj.GameCatetory = r.GameCatetory
        let fieldName = 'lang.gameCatetory.' + r.GameCatetory
        obj.GameCatetory = this.$t(fieldName)
        return obj
      })
    }
  }
}

</script>

<style lang="less" scoped>
  .betActivityRegularlyDetailsPage {
    padding-top: 50px;
    max-height: calc(100vh - 78px);
    overflow-y: scroll;

    .summary {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      height: 8vh;
      margin: 2px 0;

      .totalReceived, .totalRewards, .totalBet {
        text-align: center;
        line-height: 24px;

        .title {
          font-size: 14px;
          font-weight: 700;
          color: #686868;
        }

        .amount {
          font-size: 16px;
          font-weight: 700;
          color: #ffffff;
        }
      }
    }

    .statsByGames {
      width: 88vw;
      max-height: 20vh;
      overflow-y: scroll;
      margin: 12px 20px;
      padding: 12px;
      background-color: #2d2a26;
      border-radius: 8px;

      table {
        width: 100%;
        border-collapse: collapse;

        tr {
          line-height: 34px;

          th {
            color: #847777;
            font-weight: 700;
            border-bottom: 1px solid #504b4b;
          }

          td {
            border-bottom: 1px solid #504b4b;
          }

          td:nth-of-type(1), td:nth-of-type(2) {
            color: #c0bcbc;
          }

          td:nth-of-type(3) {
            color: #f1dab0;
          }

          th:first-of-type, td:first-of-type {
            text-align: left;
          }

          th:nth-of-type(2), td:nth-of-type(2) {
            text-align: center;
          }

          th:last-of-type, td:last-of-type {
            text-align: right;
          }
        }

        tr:last-of-type {
          td {
            border-bottom: none;
          }
        }
      }
    }

    .history {
      width: 88vw;
      margin: 24px 20px ;

      .memos {
        max-height: 40vh;
        overflow-y: scroll;
      }

      .title {
        font-size: 20px;
        font-weight: 700;
        color: #ffffff;
      }

      .memo {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #f1dab0;
        border-radius: 8px;
        margin-top: 10px;
        padding: 4px 8px;
        line-height: 24px;

        .categoryAndDate {
          display: flex;
          flex-direction: column;

          .category {
            font-size: 18px;
            font-weight: 700;
            color: #148f36;
          }

          .date {
            font-size: 12px;
            font-weight: 700;
            color: #616161;
          }
        }

        .amount {
          font-size: 18px;
          font-weight: 700;
          color: #000000;
        }
      }

      .noDataAvailable {
        font-size: 12px;
        color: #696969;
        text-align: center;
      }

      /deep/ .mint-loadmore-content {
        &:after {
          content: "020";
          display: block;
          height: 0;
          clear: both;
          visibility: hidden;
        }
        .mint-loadmore-bottom {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          height: 20px;
          line-height: 20px;
          margin-bottom: -20px;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/BetActivityRegularly/details.vue